import axiosInstance from "./axiosInstance";

/** GET /confrontation/getConfrontations — optional query: start, stop (ISO) on characterizationDate */
export const getConfrontations = (params = {}) => {
  const query = {};
  if (params.start != null && params.start !== "") query.start = params.start;
  if (params.stop != null && params.stop !== "") query.stop = params.stop;
  if (params.onlySnapshots != null) query.onlySnapshots = params.onlySnapshots;
  return axiosInstance.get("confrontation/getConfrontations", {
    params: query,
  });
};

/** GET /confrontation/getOne/:id — response { confrontation } */
export const getConfrontationById = (id) => {
  const safeId = id == null ? "" : encodeURIComponent(String(id));
  return axiosInstance.get(`confrontation/getOne/${safeId}`);
};

/** POST /confrontation/delete/:id */
export const deleteConfrontation = (id) => {
  const safeId = id == null ? "" : encodeURIComponent(String(id));
  return axiosInstance.post(`confrontation/delete/${safeId}`);
};
